// notifications.js — Notifications navigateur + son, ENTIÈREMENT LOCAL :
// API Notification native + bip généré par WebAudio (aucun fichier audio,
// aucun service de push tiers — pas de fuite d'IP ni de token vers un tiers).
// Par choix privacy, la notification n'affiche JAMAIS le contenu du message,
// seulement le pseudo de l'expéditeur.

export async function ensurePermission() {
  if (!('Notification' in window)) return false;
  if (Notification.permission === 'granted') return true;
  if (Notification.permission === 'denied') return false;
  return (await Notification.requestPermission()) === 'granted';
}

export function notifyNewMessage(fromPseudo) {
  if (!('Notification' in window) || Notification.permission !== 'granted') return;
  if (document.visibilityState === 'visible') return; // onglet visible : pas de doublon
  const n = new Notification('Nouveau message', {
    body: `De ${fromPseudo}`, // jamais le contenu
    tag: `msg-${fromPseudo}`, // regroupe les notifications par expéditeur
  });
  n.onclick = () => { window.focus(); n.close(); };
}

// Bip discret généré à la volée (sinusoïde courte), aucun asset externe.
let audioCtx = null;
export function beep() {
  try {
    const AudioContextCtor = window.AudioContext || window.webkitAudioContext;
    if (!AudioContextCtor) return false;
    audioCtx = audioCtx || new AudioContextCtor();
    if (audioCtx.state === 'suspended') Promise.resolve(audioCtx.resume()).catch(() => {});
    const osc = audioCtx.createOscillator();
    const gain = audioCtx.createGain();
    osc.frequency.value = 660;
    gain.gain.setValueAtTime(0.08, audioCtx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.0001, audioCtx.currentTime + 0.18);
    osc.connect(gain).connect(audioCtx.destination);
    osc.start();
    osc.stop(audioCtx.currentTime + 0.2);
    return true;
  } catch (_) { return false; /* audio indisponible : silencieux */ }
}
